import { render, staticRenderFns } from "./SettlementsIframe.vue?vue&type=template&id=2e4597b4&"
import script from "./SettlementsIframe.vue?vue&type=script&lang=ts&"
export * from "./SettlementsIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports